import React from 'react'

const Footer = () => {
    return (
        <footer id="footer" className="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-sm-4 text-center">
                            <div>
                                <h4 style={{ color : '#ffff'}}>
                                    <strong>¿Tienes alguna duda?</strong><br />
                                    Ponte en contacto con nosotros
                                </h4>
                            </div>
                            <p>
                                <span style={{ color : '#ffff'}}>panel@cadem.cl</span>
                            </p>
                        </div>
                        <div className="col-md-4 col-sm-4 text-center">
                            <div>
                                <a href="https://www.instagram.com/cadem_online/?hl=es-la"  target="_blank" rel="noreferrer"><img src="assets/images/instagramBlanco.png" alt="Logo Instagram" style={{ height: '50px' }} /></a>
                                <a href="https://es-la.facebook.com/panelcademonline" target="_blank" rel="noreferrer"><img src="assets/images/FacebookBlanco.png" alt="Logo Facebook" style={{ height : '50px' }} /></a>
                            </div>
                            <p className="mt-2"><a href="https://www.cademonline.cl" target="_blank" rel="noreferrer">www.cademonline.cl</a></p>
                        </div>
                        <div className="col-md-4 col-sm-4 text-center hidden-xs-down">
                            <div>
                                <a href="https://www.cademonline.cl" target="_blank" rel="noreferrer"><img src="assets/images/LOGO-CADEM-ONLINE_BLANCO.svg" alt="Logo Cadem Online" className="img-responsive" style={{ height : '70px', width: '180px' }} /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	    </footer>
    )
}

export default Footer;
